import { useCartContextDispatch } from "../context/use-cart-context";
import { getCartInfo, getCartItemsCount } from "src/utils/ct/cart-helper";
import { Cart } from "src/types/ctgraphql.d";

export function useUpdateCartContext(): (
  cart: Cart | null | undefined
) => void {
  const cartContextDispatch = useCartContextDispatch();

  return (cart: Cart | null | undefined) =>
    cartContextDispatch({
      type: "SET_CART_STATE",
      payload: {
        ...getCartInfo(cart),
        totalItems: getCartItemsCount(cart?.lineItems || []),
      },
    });
}
